function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "ic-skills_svg__a",
  width: "125%",
  height: "125%",
  x: "-12.5%",
  y: "-10.7%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feMorphology", {
  "in": "SourceAlpha",
  operator: "dilate",
  radius: 1,
  result: "shadowSpreadOuter1"
}), React.createElement("feOffset", {
  dy: 2,
  "in": "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 4
}), React.createElement("feComposite", {
  "in": "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  "in": "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
})), React.createElement("circle", {
  id: "ic-skills_svg__b",
  cx: 56,
  cy: 56,
  r: 56
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0-2h130v130H0z"
}), React.createElement("g", {
  transform: "translate(9 7)"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#ic-skills_svg__a)",
  xlinkHref: "#ic-skills_svg__b"
}), React.createElement("use", {
  fill: "#FFF",
  stroke: "#12123B",
  strokeWidth: 2,
  xlinkHref: "#ic-skills_svg__b"
})), React.createElement("path", {
  d: "M29 27h72v72H29z"
}), React.createElement("path", {
  stroke: "#12123B",
  strokeWidth: 2,
  d: "M78 37v7h8"
}), React.createElement("path", {
  fill: "#12123B",
  d: "M60 83h18v-2H60zm-6.5-30a3.497 3.497 0 00-3.5 3.495 3.497 3.497 0 003.5 3.495c1.933 0 3.5-1.564 3.5-3.495A3.497 3.497 0 0053.5 53z"
}), React.createElement("path", {
  stroke: "#12123B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M60.5 56.5h21M60.34 69h14.32"
}), React.createElement("path", {
  fill: "#12123B",
  d: "M57 69.5a3.5 3.5 0 10-6.999-.001A3.5 3.5 0 0057 69.5m.01 13c0-1.933-1.569-3.5-3.505-3.5A3.502 3.502 0 0050 82.5c0 1.933 1.569 3.5 3.505 3.5a3.502 3.502 0 003.505-3.5"
}), React.createElement("path", {
  stroke: "#12123B",
  strokeWidth: 2,
  d: "M47 36h32l7 8v44a2 2 0 01-2 2H47a2 2 0 01-2-2V38a2 2 0 012-2z"
}), React.createElement("path", {
  stroke: "#12123B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M51.5 42.5H67"
}), React.createElement("path", {
  stroke: "#12123B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M51.5 46.5H63"
}), React.createElement("g", {
  transform: "translate(14.49 8.098)"
}, React.createElement("circle", {
  cx: 13.176,
  cy: 13.176,
  r: 12.176,
  fill: "#FFF",
  stroke: "#12123B",
  strokeWidth: 2
}), React.createElement("path", {
  fill: "#12123B",
  d: "M14.772 12.603c.717.202 1.26.546 1.63 1.033.369.488.554 1.1.554 1.84 0 1.03-.361 1.842-1.084 2.436-.722.594-1.7.89-2.931.89a6.238 6.238 0 01-2.092-.352c-.666-.236-1.23-.56-1.688-.975a.827.827 0 01-.336-.672c0-.201.056-.372.168-.512a.502.502 0 01.403-.21c.168 0 .358.073.571.218.482.359.955.63 1.42.815.464.185.966.277 1.503.277 1.59 0 2.386-.677 2.386-2.033 0-.66-.21-1.156-.63-1.486-.42-.33-1.056-.496-1.907-.496h-.924a.637.637 0 01-.504-.21.726.726 0 01-.185-.496c0-.179.062-.338.185-.478a.637.637 0 01.504-.21h.655c.818 0 1.442-.171 1.873-.513.432-.341.647-.843.647-1.503 0-.583-.176-1.036-.529-1.361-.353-.325-.848-.487-1.487-.487-.94 0-1.881.364-2.822 1.092-.213.145-.403.218-.571.218a.502.502 0 01-.404-.21.794.794 0 01-.168-.512c0-.27.112-.493.336-.672a4.965 4.965 0 011.672-.975 5.948 5.948 0 012.024-.353c1.11 0 1.991.275 2.646.824.656.548.983 1.293.983 2.234 0 .672-.165 1.257-.495 1.756-.33.498-.798.86-1.403 1.083z"
})));

var SvgIcSkills = function SvgIcSkills(props) {
  return React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,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";
export { SvgIcSkills as ReactComponent };